import React, { FC } from 'react';

const Page404: FC = () => (
  <section className="static-page-section not-found-page" style={{ backgroundColor: '#FFFFFF' }}>
    <div className="container">
      <p className="user-fs-text" style={{ marginTop: 10 }}>
        Page Not Found - 404
      </p>
    </div>
  </section>
);

export default Page404;
